import * as Yup from 'yup';

export const InitialGroupState = {
    name: "",
    permissions: []
};

export const GroupSchema = Yup.object().shape({
    name: Yup.string().required(),
    permission: Yup.array().min(1)
});